import React, { Component } from 'react';
import './CursorFollower.css'; // Import your CSS file

class CursorFollower extends Component {
  constructor() {
    super();
    this.state = {
      cursorX: 0,
      cursorY: 0,
      isHovering: false,
      shouldExpand: false, // New state to control expansion
    };
  }

  componentDidMount() {
    document.addEventListener('mousemove', this.handleMouseMove);
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove);
  }

  handleMouseMove = (event) => {
    this.setState({
      cursorX: event.pageX,
      cursorY: event.pageY,
    });
  };

  handleMouseEnter = () => {
    this.setState({
      isHovering: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovering: false,
    });
  };

  handleExpand = () => {
    this.setState({
      shouldExpand: true,
    });
  };

  handleCollapse = () => {
    this.setState({
      shouldExpand: false,
    });
  };

  render() {
    const { cursorX, cursorY, isHovering, shouldExpand } = this.state;
    const cursorSize = shouldExpand ? '100px' : (isHovering ? '50px' : '15px');

    return (
      <div>
        <div
          className={`cursor cursor-follower ${isHovering ? 'focus' : ''}`}
          style={{
            left: cursorX,
            top: cursorY,
            width: cursorSize,
            height: cursorSize,
          }}
        ></div>
        <div
          className={`cursor cursor-dot ${isHovering ? 'focus' : ''}`}
          style={{
            left: cursorX,
            top: cursorY,
          }}
        ></div>
      </div>
    );
  }
}

export default CursorFollower;
